export default `# Drelo — Aviso de Política DMCA (Borrador)

**Última actualización:** 23 de junio de 2026
**Agente designado registrado:** Pryma Wellness Group Inc. — registro #DMCA-1074585 (dmca.copyright.gov/osp), activo desde el 22/06/2026.

## Respeto a la propiedad intelectual

Drelo respeta los derechos de propiedad intelectual de terceros. Si el Sitio permite a los usuarios subir contenido (por ejemplo, fotos en reseñas de producto), y crees que algún contenido publicado en Drelo infringe tus derechos de autor, puedes presentar una notificación conforme a la Digital Millennium Copyright Act (DMCA).

## Cómo presentar una notificación de infracción

Tu notificación por escrito debe incluir:

1. Identificación de la obra protegida por derechos de autor que consideras infringida.
2. Identificación del contenido en Drelo que consideras infractor, con su ubicación (URL o descripción suficiente para localizarlo).
3. Tu información de contacto (nombre, dirección, teléfono, correo electrónico).
4. Una declaración de que crees de buena fe que el uso no está autorizado por el titular de los derechos, su agente, o la ley.
5. Una declaración, bajo pena de perjurio, de que la información en la notificación es precisa y que tienes autorización para actuar en nombre del titular de los derechos.
6. Tu firma física o electrónica.

Envía la notificación a:

**Agente Designado DMCA**
Pryma Wellness Group Inc.
16192 Coastal Highway, Lewes, DE 19958, EE.UU.
privacidad@drelo.shop

## Contranotificación

Si tu contenido fue removido por una notificación DMCA y consideras que fue un error, puedes presentar una contranotificación con la información equivalente a la anterior, declarando bajo pena de perjurio que el contenido fue removido por error o identificación incorrecta.

## Infractores reincidentes

Drelo se reserva el derecho de remover contenido y/o terminar cuentas de usuarios que infrinjan repetidamente derechos de autor de terceros.
`;
